import {createMuiTheme} from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import red from '@material-ui/core/colors/red';
import grey from '@material-ui/core/colors/grey';

import yellow from '@material-ui/core/colors/yellow';



const theme = createMuiTheme({
    palette: {
        primary: {
          main: blue[800]
         
        },
        secondary: {
          main: red[400]
        },
        
        greyFondo :{
          main : grey[200]
        },
        fondotitulos: {
          main: blue[100]
        },
        fondoSeleccionIndicador:{
          main: blue[100]
        },
        fondoIndicadorRiesgoAlto:{
          main : red[500]
        },
        fondoIndicadorRiesgoMed :{
          main : yellow[500]
        },
        fondoIndicadorBajo: {
          main: blue[700]
        },
        fondoiconos: {
          main: blue[300]
        },
        alerta:{
          main: yellow[50]
        }
      
      },


    
});

export default theme;
